import Api from "~/service/Api";

class UiMeet3dEventRepository {
  fetch(query) {
    return Api.get("/ui-meet-3d/events", query);
  }

  fetchOne(uiMeet3dEventId) {
    return Api.get(`/ui-meet-3d/events/${uiMeet3dEventId}`);
  }
}

export default UiMeet3dEventRepository;
